export default Object.freeze({
	Light: 'Light',
	Dark: 'Dark',
	Peach: 'Peach',
	Multicolor: 'Multicolor',
});
